import { render, staticRenderFns } from "./SafetyInformation.vue?vue&type=template&id=56815e57&scoped=true"
import script from "./SafetyInformation.vue?vue&type=script&lang=js"
export * from "./SafetyInformation.vue?vue&type=script&lang=js"
import style0 from "./SafetyInformation.vue?vue&type=style&index=0&id=56815e57&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56815e57",
  null
  
)

export default component.exports